module.exports = __webpack_public_path__ + "7c8f476123d28d103efe381543274c25.png";